import { Box, HStack, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';

import { colors } from '~/packages/common-frontend/colors';
import { Icon } from '~/packages/common-frontend/components/icons';

export const CheckAvailabilityRow = ({
  clickRow,
  value,
  label,
  tooltip,
  rowIcon,
  actionComponent,
}: {
  clickRow?: () => void;
  rowIcon?: string;
  value: string;
  label: string;
  tooltip?: string;
  actionComponent?: React.ReactNode;
}) => {
  return (
    <HStack
      w="100%"
      spacing="16px"
      alignItems="center"
      borderBottom={`1px solid ${colors.gray[200]}`}
      p="16px"
      _hover={{ backgroundColor: clickRow && colors.gray[50] }}
      cursor={clickRow && 'pointer'}
      onClick={clickRow}
    >
      {rowIcon ? <Icon icon={rowIcon} /> : <Box w="16px" />}
      <Text>{label}</Text>
      {tooltip && (
        <Tooltip label={tooltip}>
          <span>
            <Icon icon="info-circle" color={colors.blue[400]} />
          </span>
        </Tooltip>
      )}
      <Box flexGrow={1} textAlign="right">
        <Text>{value}</Text>
      </Box>
      <HStack sx={{ w: '3em', justifyContent: 'flex-end' }}>
        {actionComponent}
      </HStack>
    </HStack>
  );
};
